import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { getTestUsers } from "@/lib/api";

export const TestUsersPage = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getTestUsers();
        setUsers(data);
      } catch {
        toast.error("Unable to load test users");
      }
    };
    load();
  }, []);

  return (
    <div className="auth-page-bg" data-testid="test-users-page">
      <div className="auth-card wide" data-testid="test-users-card">
        <h1 className="auth-title">Aavedak Test Users</h1>
        <p className="auth-subtitle">Default role password for created role users: Akku@2507</p>

        <div className="table-wrap" data-testid="test-users-table">
          <table>
            <thead>
              <tr>
                <th>Role</th>
                <th>Login</th>
                <th>Password</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {users.map((item, idx) => (
                <tr key={`${item.role}-${idx}`} data-testid={`test-user-row-${idx}`}>
                  <td>{item.role}</td>
                  <td>{item.login}</td>
                  <td>{item.password}</td>
                  <td>{item.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="inline-actions">
          <Button variant="outline" onClick={() => window.history.back()} data-testid="test-users-back-button">
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};
